import { FrequentUsed as IconFrequentUsed } from '@ahamove/icons/map';
import { getAddressLabels } from '@ahm/api-wrappers-core';
import { Combobox, Divider, Group, Stack, Text, rem } from '@mantine/core';
import { useMediaQuery } from '@mantine/hooks';
import classes from '../address-autocomplete.module.css';
import { AddressAutocompleteItem } from '../autocomplete-item';
import { createTranslations, locales } from '../locales';
import type { FrequentAddressOptionsProps } from '../types';

const FrequentAddressOptions = ({
  currentInputValue,
  options,
  lang = 'vi',
}: FrequentAddressOptionsProps) => {
  const isMobile = useMediaQuery('(max-width: 767px)');
  const t = createTranslations({ locales, lang });

  if (!options || options.length < 1) {
    return null;
  }

  return (
    <Stack gap={0} bg="white">
      <Group px="md" py={isMobile ? 'sm' : 'md'} justify="space-between">
        <Text component="h6" fw={700} fz={rem(16)}>
          {t('frequently_used')}
        </Text>
      </Group>
      {isMobile ? <Divider color="neutral.0" /> : null}
      {options.map((addr, idx) => {
        const [firstLabel] = getAddressLabels(addr.address);
        return (
          <Combobox.Option
            component="div"
            className={classes.option}
            title={addr.address}
            value={addr.address}
            key={`${idx}_${!addr.lat || !addr.lng ? `${addr.lat}_${addr.lng}` : addr.place_id}`}
          >
            <AddressAutocompleteItem
              hls={currentInputValue}
              primary={addr.first_label ?? firstLabel}
              secondary={addr.address}
              icon={<IconFrequentUsed width={24} height={24} />}
            />
          </Combobox.Option>
        );
      })}
    </Stack>
  );
};

export default FrequentAddressOptions;
